import React from "react";

import Navbar from "../components/Navbar";
import Heroimage from "../components/Heroimage";
import Footer from "../components/Footer";
// eslint-disable-next-line no-unused-vars
const home = () => {
    return (
        <div>
            <Navbar/>
            <Heroimage/>
            <Footer/>
        </div>
    )
}

// eslint-disable-next-line no-unused-vars

export default home;

